import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "arch-switcher" }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 0,
  class: "arch-switcher__label"
}
const _hoisted_4 = { class: "arch-switcher-menu" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "arch-switcher-menu__name" }
const _hoisted_7 = { class: "arch-switcher-menu__alias" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "arch-switcher-menu__alias" }
const _hoisted_10 = {
  key: 0,
  type: "button",
  class: "arch-switcher__trigger arch-switcher__trigger--collapsed",
  disabled: ""
}
const _hoisted_11 = ["title"]
const _hoisted_12 = {
  key: 0,
  class: "arch-switcher__sep"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_menu, {
      modelValue: _ctx.orgMenuOpen,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orgMenuOpen) = $event)),
      location: "bottom start",
      offset: 4,
      "close-on-content-click": false
    }, {
      activator: _withCtx(({ props }) => [
        _createElementVNode("button", _mergeProps({
          type: "button",
          class: "arch-switcher__trigger"
        }, props, { title: _ctx.unavailableHint }), [
          (_ctx.current)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Организация: "))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: _normalizeClass(["arch-switcher__value", {'arch-switcher__value--unavailable': !_ctx.current}])
          }, _toDisplayString(_ctx.activeTitle), 3),
          _createVNode(_component_v_icon, {
            icon: "mdi-chevron-down",
            class: _normalizeClass(["arch-switcher__chevron", {'arch-switcher__chevron--open': _ctx.orgMenuOpen}]),
            size: "20"
          }, null, 8, ["class"])
        ], 16, _hoisted_2)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.recent.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "arch-switcher-menu__section" }, "НЕДАВНИЕ", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recent, (right) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: 'recent-' + right.alias,
                    type: "button",
                    class: "arch-switcher-menu__row",
                    onClick: ($event: any) => (_ctx.onPick(right))
                  }, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.displayTitle(right)), 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(right.alias), 1)
                  ], 8, _hoisted_5))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.all.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "arch-switcher-menu__section" }, "ВСЕ", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all, (right) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: 'all-' + right.alias,
                    type: "button",
                    class: _normalizeClass(["arch-switcher-menu__row", {'arch-switcher-menu__row--selected': right.alias === _ctx.activeAlias}]),
                    onClick: ($event: any) => (_ctx.onPick(right))
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["arch-switcher-menu__name", {'arch-switcher-menu__name--selected': right.alias === _ctx.activeAlias}])
                    }, _toDisplayString(_ctx.displayTitle(right)), 3),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(right.alias), 1)
                  ], 10, _hoisted_8))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["arch-switcher-menu__footer", {'arch-switcher-menu__footer--ruled': _ctx.all.length}]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onAdvancedSearch && _ctx.onAdvancedSearch(...args)))
          }, " Расширенный поиск → ", 2)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.branchSwitcherEnabled)
      ? (_openBlock(), _createElementBlock("button", _hoisted_10, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "arch-switcher__label" }, "Ветка: ", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "arch-switcher__value" }, "main", -1)),
          _createVNode(_component_v_icon, {
            class: "arch-switcher__chevron",
            size: "20",
            icon: "mdi-chevron-down"
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.crumbs.length)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "arch-switcher__crumbs",
          title: _ctx.crumbsLabel
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crumbs, (crumb, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: index,
              class: "arch-switcher__part"
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["arch-switcher__crumb", {'arch-switcher__crumb--last': index === _ctx.crumbs.length - 1}])
              }, _toDisplayString(crumb), 3),
              (index < _ctx.crumbs.length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, " / "))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 8, _hoisted_11))
      : _createCommentVNode("", true)
  ]))
}